import { Code2, GitBranch, Server } from 'lucide-react'

import { LandingPageData } from '../../components/landing/landing-page'
import profileImage from '../profile.jpg'
import { resume } from '../resume/de'

export const landing: LandingPageData = {
  profile: {
    name: resume.introduction.name,
    image: profileImage,
  },
  contacts: {
    overline: 'Bereit für den Launch?',
    headline:
      'Egal ob du einen Lead Developer suchst, der das Projekt vorantreibt, oder einen Architecture Review brauchst, um dein Team zu entlasten – lass uns reden.',
    email: resume.contacts.email,
    phone: resume.contacts.phone,
  },
  hero: {
    headline: 'Architektur, die Business versteht.',
    description:
      'Ich verwandle komplexe Anforderungen in stabile, produktionsreife Software. Dabei kombiniere ich tiefes Backend- und Frontend-Know-how mit einem DevOps-Mindset, um Lösungen zu schaffen, die dein Unternehmen wirklich weiterbringen.',
  },
  philosophy: {
    headline: 'Vom Prozess in die Produktion',
    overline: 'Prozess • Dev • Ops',
    claims: [
      {
        title: 'Prozesse gestalten',
        description:
          'Mit BPMN und Camunda stelle ich sicher, dass die technische Lösung exakt zur Geschäftsrealität passt.',
        icon: GitBranch,
      },
      {
        title: 'Den Kern bauen',
        description:
          'Full-Stack Entwicklung (Java, React, Angular) mit Fokus auf Stabilität und langfristige Wartbarkeit.',
        icon: Code2,
      },
      {
        title: 'Betrieb automatisieren',
        description:
          'CI/CD und IaC aus der Perspektive eines Systems Engineers – damit manuelle Ops das Business nicht ausbremsen.',
        icon: Server,
      },
    ],
  },
  outcomes: {
    headline: 'Ergebnisse, die zählen',
    overline: 'Rolle • Branche',
    outcomes: [
      {
        industry: 'Behörde / Öffentlicher Sektor',
        role: 'Lead Developer',
        description:
          'Über 50.000 monatliche Transaktionen durch die Digitalisierung manueller Workflows in ausführbare Camunda-Prozesse automatisiert.',
      },
      {
        industry: 'Digital Rights Management',
        role: 'Frontend Architect',
        description:
          'Einführung einer Unified Component Library & Design System (Angular/Nx), um die UI über mehrere Enterprise-Apps hinweg zu standardisieren.',
      },
      {
        industry: 'Lebensversicherung',
        role: 'DevOps Engineer',
        description:
          'Garantierte Konsistenz über 6 Stages durch Umstellung der Infrastruktur auf Terraform und GitOps – keine manuellen Konfigurationsfehler mehr bei Releases.',
      },
    ],
  },
  services: {
    headline: 'Wie ich unterstützen kann',
    overline: 'Contracting • Consulting',
    offers: [
      {
        headline: 'Entwicklung & Architektur',
        overline: 'Contracting',
        bullets: [
          'Lead Developer für Enterprise-Projekte.',
          'Umsetzung von der Architektur bis zum Deployment.',
          'Legacy-Modernisierung & Cloud-Migration.',
        ],
      },
      {
        headline: 'Architektur & DevOps Reviews',
        overline: 'Consulting',
        bullets: [
          'Gezielte Audits deines aktuellen Tech-Stacks und Workflows.',
          'Scalability-Assessments und Security Best Practices.',
          'Health Checks für deine Camunda/BPMN-Implementierung.',
        ],
      },
    ],
  },
  technologies: {
    headline: 'Mein Werkzeugkoffer',
    overline: 'Backend • Frontend • DevOps',
    items: [
      'Java',
      'Kotlin',
      'Spring Boot',
      'Camunda (BPMN/DMN)',
      'React',
      'Angular',
      'Vue',
      'Kubernetes',
      'Terraform',
      'AWS',
      'GCP',
      'OpenShift',
      'ArgoCD',
      'Docker',
      'PostgreSQL',
    ],
  },
}
